/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SkuInfoStatusEnum = 'ACTIVE' | 'INACTIVE';

export const SkuInfoStatusEnum = {

    ACTIVE: 'ACTIVE' as SkuInfoStatusEnum,

    INACTIVE: 'INACTIVE' as SkuInfoStatusEnum
};

